import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import 'vant/lib/index.css';
import 'vant/es/toast/style';
import './styles/index.scss';
import './insurance-plan/styles/ui.scss';
import 'lib-flexible';
import { installProposalCompat } from './insurance-plan/components/uniCompat';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
installProposalCompat(app);
app.mount('#app');
